import { siteSlugFromId } from '@atbash-labs/ontology-core'

/** Label for a site picker row: keep a human name, never show a raw URN. */
export function siteOptionLabel(name: string | undefined, id: string): string {
  const trimmed = name?.trim()
  if (trimmed && !trimmed.startsWith('urn:') && !trimmed.includes('/site:')) return trimmed
  return siteSlugFromId(id || trimmed || '') || trimmed || id
}

/** Slug used as a free-text site / gateway / controller id when the graph URN is not available. */
export function slugifyId(value: string): string {
  const slug = value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
  return slug || 'site'
}

export function fileStem(fileName: string): string {
  return fileName.replace(/\.[^.]+$/, '').trim() || fileName
}

export function hostFromUrl(raw: string | undefined): string | null {
  if (!raw?.trim()) return null
  try {
    const withScheme = /^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(raw.trim())
      ? raw.trim()
      : `http://${raw.trim()}`
    const host = new URL(withScheme).hostname
    return host || null
  } catch {
    return null
  }
}

export function resolveSiteId(opts: {
  mode: 'new' | 'existing' | null
  existingSiteId: string | null
  newSiteName: string
}): string {
  if (opts.mode === 'existing' && opts.existingSiteId?.trim()) {
    return siteSlugFromId(opts.existingSiteId)
  }
  return slugifyId(opts.newSiteName || 'site')
}

export function resolveGatewayId(opts: {
  siteId: string
  gatewayUrl?: string
  agentUrl?: string
}): string {
  const fromGateway = hostFromUrl(opts.gatewayUrl)
  if (fromGateway) return slugifyId(fromGateway)
  const fromAgent = hostFromUrl(opts.agentUrl)
  if (fromAgent) return slugifyId(fromAgent)
  return `${slugifyId(siteSlugFromId(opts.siteId))}-gw`
}
